<template>
  <div>
    <div class="row">
      <h1 class="col-8 primary-text">{{ title }}</h1>
      <div @click="goToProductList(isOnline,type,title,items[0].ProductCategoryID)"  class="col-4 text-left ">
        <span class="primary-text ml-2 pointer">MORE</span>
        <i class="fa-solid fa-arrow-left fa-lg pointer"></i>
      </div>
    </div>
    <div v-if="dataLoading" class="row align-items-center ">
      <div v-for="(i) in 9" :key="i" class="col-4 d-block p-2">
        <v-skeleton-loader
            class="mx-auto border"
            type="image"></v-skeleton-loader>
      </div>
    </div>
    <div v-else-if="items.length > 0 && items !== undefined" class="row">

      <router-link :to="{name:'ProductDetail',query:{VendorProductID:item.VendorProductID}}" v-for="(item,i) in items.slice(0,9)" :key="i" class="col-4 d-block p-2">

        <v-img :src="$replaceHttps(item.FileUrl)" alt="تصویر..." class="rounded-11px bg-white" contain aspect-ratio="1"></v-img>
      </router-link>

      </div>
  </div>
</template>

<script>
export default {
  name: "GridTemplate",
  props: ['items', 'title', 'dataLoading','type','isOnline'],
  data:()=>({
    sliceItems:[]
  }),
  mounted() {
  },
  methods: {
    getImgUrl(pic) {
      return require("../assets/img/" + pic);
    },
    goToProductList(isOnline,type,title,ProductCategoryID){
      if(isOnline === 'true') {
        this.$router.push({
          path: 'ProductsList',
          query: {isOnline: isOnline, type: type, Name: title, ProductCategoryID: ProductCategoryID}
        })
      }else {
        this.$router.push({
          path: 'ProductsList',
          query: {isOnline: isOnline, type: type, Name: title}
        })
      }

    }
  }
}
</script>

<style scoped>

</style>
